import React, { useEffect, useState } from 'react'
import { IDriverSearchObject } from 'src/types'
import { getDriverSchedule } from 'src/state/actions/drivers'
import DriverViewScheduleWorkingHours from './DriverViewScheduleWorkingHours'
import FloatingForm from '../ui/form/FloatingForm'
import { MoonLoader } from 'react-spinners'

export interface IDriverViewScheduleProps {
  operatorId: string
  orgId: string
  currentOperator: IDriverSearchObject
}

export interface IDriverSchedule {
  days: string[]
  from: string
  is_archived: boolean
  until: string
  errorDays?: string[]
}

export interface IDriverScheduleResponse {
  success: boolean
  serviceDays: IDriverSchedule[]
}

const DriverViewSchedule = (props: IDriverViewScheduleProps) => {
  const { currentOperator, operatorId } = props
  const [isAllDaysActive, setIsAllDaysActive] = useState(false)
  const [loading, setLoading] = useState(true)
  const [workingHoursList, setWorkingHoursList] = useState<IDriverSchedule[]>([])

  useEffect(() => {
    fetchDriverSchedule(operatorId)
  }, [])

  const fetchDriverSchedule = async (operatorId: string) => {
    const response: IDriverScheduleResponse = await getDriverSchedule(operatorId)
    setWorkingHoursList(response.serviceDays)
    setLoading(false)
  }

  return (
    <FloatingForm fullHeight={true}>
      <>
        <div className='form-modal-section full-section'>
          <div className='font-grey2 bold h5 mb1'>Flexible Availability Schedule</div>
          {loading ? (
            <div className='p3 m3 flex items-center justify-center h5 font-grey2'>
              <MoonLoader sizeUnit={'px'} size={40} color={'#405264'} loading={true} />
            </div>
          ) : null}
          {workingHoursList.length === 0 && loading !== true && (
            <div className='flex justify-center items-center my1 p3 font-grey border-light-grey4 rounded h5'>
              No Existing Driver Schedule
            </div>
          )}
          <DriverViewScheduleWorkingHours workingHoursList={workingHoursList} />
        </div>
      </>
    </FloatingForm>
  )
}

export default DriverViewSchedule



// WEBPACK FOOTER //
// ./src/components/drivers/DriverViewSchedule.tsx